import * as dayjs from 'dayjs'

/**
 * date format
 * @param {string} date - 포맷 적용할 날짜
 * @returns 포맷 적용된 날짜
 */
const dateFormat = date => {
  if (!date) return false

  if (date.length > 8) {
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return dayjs(date).format('YYYY-MM-DD')
  }
}

//현재 날짜 구하기
const nowDate = () => {
  let date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let today = date.getDate()

  return year + '년 ' + month + '월 ' + today + '일'
}

const onlyNum = data => {
  return data
    .replace(/[^0-9.]/g, '')
    .replace(/(\..*?)\..*/g, '$1')
    .replace(/^0[^.]/, '0')
}

// 사업자번호 체크
function checkCorporateRegiNumber(number) {
  console.log('checkCorporateRegiNumber', number); //remove this log
  let numberMap = number
    .toString()
    .replace(/-/gi, '')
    .split('')
    .map(function (d) {
      return parseInt(d, 10)
    })
  if (numberMap.length === 10 || numberMap.length === 14) {
    const keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5]
    let chk = 0

    keyArr.forEach(function (d, i) {
      chk += d * numberMap[i]
    })

    chk += parseInt((keyArr[8] * numberMap[8]) / 10, 10)

    return Math.floor(numberMap[9]) === (10 - (chk % 10)) % 10
  }

  return false
}

function dataFormat(date) {
  if (date?.length < 10) {
    let year = date?.substr(0, 4)
    let month = date?.substr(4, 2)
    let day = date?.substr(6, 2)
    return year + '.' + month + '.' + day
  } else {
    return
  }
}

function dataFormatPayment(date) {
  if (date?.length < 10) {
    return dayjs(date).add(2, 'month').format('YYYY.MM.01')
  } else {
    return
  }
}

/**
 * biz number format
 * @param {string} number
 * @returns 포맷 적용된 사업자번호
 */
const bizNumFormat = number => {
  if (!number) return number
  return number.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
}

/**
 * biz number format 14 digit
 * @param {string} number
 * @returns 포맷 적용된 사업자번호
 */
const bizNumFormat14Digit = number => {
  if (!number) return number
  if(number.length === 10) return number
  return number.replace(/(\d{10})(\d{4})/, '$1-$2')
}

/**
 * phone number format
 * @param {string} number
 * @returns 포맷 적용된 휴대폰번호
 */
const phoneFormat = number => {
  if (!number) return ''

  const pattern = /^(1544|1566|1577|1588|1644|1688)-?([0-9]{4})$/
  const newNumber = number.replaceAll('-', '')

  if (pattern.test(newNumber)) {
    return newNumber.replace(pattern, '$1-$2')
  }

  return newNumber
    .replace(/[^0-9]/g, '')
    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
    .replace('--', '-')
}

export { dateFormat, nowDate, checkCorporateRegiNumber, dataFormat, dataFormatPayment, phoneFormat, bizNumFormat, bizNumFormat14Digit, onlyNum }
